import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Make sure BrowserRouter is correctly used
// import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import PropertyDetailsPage from "./pages/PropertyDetailsPage";

function App() {
  return (
    <Router>
      <div className="App">
        {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/property/:propertyId"
            element={<PropertyDetailsPage />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
